function requireAll(r) { r.keys().forEach(r) }

export const wbComponents = angular.module('wbComponents', ['wbServices'])

// Import ordinary JS files automatically
requireAll(require.context('./', true, /\/.*\/index\.(js|ts|coffee)$/))
